enum ObjectFieldTypeEnum {
  NONE = 'none',
  MAIN_SECTION = 'main-section',
  ACCORDION = 'accordion',
}

export default ObjectFieldTypeEnum;
